export default __webpack_public_path__ + "static/edi-18e77e7c5ffceb9f833ec7f7c486a7e8.svg";